<cm-custom-dropdown
    class="select-search-control"
    [disabled]="disabled"
    [placeholder]="selectedOption?.name"
    [dropDownMenu]="dropdownMenu"
></cm-custom-dropdown>
<ng-template #dropdownMenu let-dropdownRef>
    <cm-search-input
        (valueDebouncedChange)="onSearch($event)"
        [minSearchLength]="minSearchLength"
        class="search-control"
    >
    </cm-search-input>
    <div class="empty-list" *ngIf="!options?.length">{{config.noEntries}}</div>
    <ul class="option-list">
        <li
            *ngFor="let option of options"
            [title]="option.name"
            class="option"
            [class.option-active]="selectedOption?.id === option.id"
            (click)="onOptionSelect(option, dropdownRef )"
        >
            {{ option.name }}
        </li>
    </ul>
</ng-template>